
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api/index';
import VoteButton from '../components/VoteButton.vue';

@Component({
  components: { VoteButton },
})
export default class Detail extends Vue {
  voteNum = '';
  voteName = '2022project/q1/2022manufacture';
  detailData: any = {};
  get detail() {
    return this.$route.query;
  }
  async created() {
    const res = await getDetail(this.detail.id as string);
    this.detailData = res.data;
    this.voteNum = this.detailData.votes;
  }
  votSuccess(data: any) {
    this.voteNum = data;
  }
}
